import { render } from "./ProductHuntButton.vue?vue&type=template&id=3bd6df8e"
import script from "./ProductHuntButton.vue?vue&type=script&lang=js"
export * from "./ProductHuntButton.vue?vue&type=script&lang=js"

import "./ProductHuntButton.vue?vue&type=style&index=0&id=3bd6df8e&lang=css"

import exportComponent from "../../../.yarn/__virtual__/vue-loader-virtual-6763a87ef6/0/cache/vue-loader-npm-17.4.2-00674d01e5-ffbe3e848e.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__